import links from 'links'
import { Link } from 'router'


type LinkWrapperProps = {
  children: React.ReactNode
  isLink: boolean
};

const LinkWrapper: React.FC<LinkWrapperProps> = ({ children, isLink }) => {
  if (isLink) {
    return (
      <Link to={links.smartRecommendations}>
        {children}
      </Link>
    )
  }

  return (
    <>
      {children}
    </>
  )
}

export default LinkWrapper
